<div class="start-menu-header-cards-container">
  @for (card of cards; track card) {
    <div
      (click)="selected(card)"
      [ngClass]="{ 'header-card-disabled': card.disabled }"
      [title]="card.disabledTooltip"
      class="header-card"
      >
      @if (card.completed) {
        <div class="check-complete"></div>
      }
      <div [ngClass]="card.backgroundClass" class="header-card-background"></div>
      <div class="header-card-title-container">
        <div class="header-card-title-and-icon-container">
          <span class="header-card-title">{{ card.title }}</span>
          @if (card.titleImageSrc) {
            <img
              [src]="card.titleImageSrc"
              class="header-card-image"
              style="height: 3.125rem; width: 3.125rem"
              />
          }
        </div>
        @if (card.subtitle) {
          <span class="header-card-subtitle">{{ card.subtitle }}</span>
        }
      </div>
      @if (card.contentType === 'image') {
        <div class="header-content-image">
          <img [src]="card.imageSrc" />
        </div>
      }
      @if (card.contentType === 'links') {
        <div class="header-content-links" id="HeaderContentLinks">
          @for (link of card.links; track link; let i = $index) {
            <span
              (click)="openLink(link)"
              class="header-content-link-container"
              >
              {{ link.text + (i < card.links.length - 1 ? ', ' : '') }}
            </span>
          }
        </div>
      }
      <div class="header-card-link-container">
        @if (card.showSpinner) {
          <span class="spinner"></span>
        }
        <span class="header-card-link">{{ card.linkText }}</span>
      </div>
    </div>
  }
</div>
